import type { Instance, SnapshotOut } from 'mobx-state-tree';
import { types } from 'mobx-state-tree';

/**
 * Order Event model.
 */
export const OrderEventModel = types.model('OrderEvent', {
  pickupLocationName: types.maybe(types.string),
  pickupTime: types.Date,
  pickupTimeEnd: types.Date,
  pickupTimeStart: types.Date,
  productGroupId: types.maybe(types.string),
  scheduleId: types.string,
});

type OrderEventType = Instance<typeof OrderEventModel>;
export type OrderEvent = OrderEventType;
type OrderEventSnapshotType = SnapshotOut<typeof OrderEventModel>;
export type OrderEventSnapshot = OrderEventSnapshotType;
export const createOrderDefaultModel = () => types.maybe(OrderEventModel);
